/* unplugin-vue-components disabled */import { render } from "./output.vue?vue&type=template&id=5d448b81&scoped=true"
import script from "./output.vue?vue&type=script&lang=js"
export * from "./output.vue?vue&type=script&lang=js"

import "./output.vue?vue&type=style&index=0&id=5d448b81&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d448b81"],['__file',"src/pages/playground/output.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d448b81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d448b81', __exports__)) {
    api.reload('5d448b81', __exports__)
  }
  
  module.hot.accept("./output.vue?vue&type=template&id=5d448b81&scoped=true", () => {
    api.rerender('5d448b81', render)
  })

}


export default __exports__